module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "bgImg"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "login_input"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm loginFrom",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "账号",
      "autocomplete": "off",
      "prefix-icon": "iconfont hohofast-zhanghao"
    },
    model: {
      value: (_vm.ruleForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "userName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "password",
      "autocomplete": "off",
      "placeholder": "密码",
      "prefix-icon": "iconfont hohofast-login_mima"
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('el-checkbox', {
    staticStyle: {
      "color": "#a0a0a0",
      "margin-bottom": "20px"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住账号密码")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeMessage))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitFormTest('ruleForm')
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer_login"
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/HelpPage"
    }
  }, [_vm._v("帮助")])], 1), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('p', [_vm._v(" Copyright 上海全服通信技术有限公司 © 2016-2026 版权所有。")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo"
  }, [_c('h5', [_vm._v("全服到家后台管理系统")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:SetHome(this,window.location);"
    }
  }, [_vm._v("设为首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:bookmark(document.title,window.location);"
    }
  }, [_vm._v("加入收藏")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/?lang=en_US"
    }
  }, [_vm._v("English(US)")]), _vm._v("   "), _c('a', {
    attrs: {
      "href": "/?lang=zh_CN"
    }
  }, [_vm._v("简体中文")])])
}]}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-6aa1533a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 1703
// module chunks = 0